
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export type SlippageMode = 'AUTO' | 'CUSTOM';

export interface SlippageSettings {
    mode: SlippageMode;
    value: number; // Percentage (e.g. 0.5 for 0.5%)
}

export const SLIPPAGE_PRESETS = [0.1, 0.5, 1.0];
export const DEFAULT_SLIPPAGE = 0.5;
export const MAX_SLIPPAGE = 50;
